import React from 'react';
import { Table, Pagination } from 'rsuite';
import { exists } from '../../../../../common/utilities/utilitiesFunctions';
import { getRowCssClass } from '../index.service';
import { translate } from 'react-i18next';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import "rsuite/dist/rsuite.min.css";
import './WorkplanShiftlineTable.scss';

const { Column, HeaderCell, Cell } = Table;

const WorkplanShiftlineTable = ({
    classes,
    selectedWorkPlan,
    editMode,
    columns,
    height,
    limit,
    page,
    handleChangePage,
    handleChangeLimit,
    t,
}) => {
    let defaultShiftlineData = [];
    if (exists(selectedWorkPlan.shiftLines)) {
        defaultShiftlineData = [...selectedWorkPlan.shiftLines.filter((x) => !x.markedForDeletion && x.id !== undefined)];
    }

    const shiftlineData = defaultShiftlineData.filter((v, i) => {
        const start = limit * (page - 1);
        const end = start + limit;
        return i >= start && i < end;
    });

    const ShiftTemplateCell = ({ rowData, column, dataKey, ...props }) => {
        return (
            <Cell 
                className={`${column.className || ''} table-cell`} 
                dataKey={column.field} 
                {...props}
            >
                {column.render(rowData)}
            </Cell>
        );
    };

    return (

        <div className={classes.tableContainer}>
            <Table
                isTree
                style={{ margin: "0 20px" }}
                data={shiftlineData}
                rowHeight={rowData => {
                    let rowHeight;
                    if (exists(rowData) && exists(rowData.maxItemsByDay)) {
                        rowHeight = 60 + (rowData.maxItemsByDay - 1) * 40;
                    } else {
                        rowHeight = 60;
                    }
                    return rowHeight
                }}
                rowKey="id"
                virtualized
                bordered={true}
                height={height - 195}
                shouldUpdateScroll={false}
                rowClassName={rowData =>
                    getRowCssClass(rowData, editMode)
                }
                renderEmpty={() => {
                    return <>
                        <div className={"rs-table-body-info"}>
                            {t('workPlan.noResults')}
                        </div></>;

                }}
                renderTreeToggle={(icon, rowData, expanded) => {
                    if (rowData.children && rowData.children.length === 0) {
                        return <></>;
                    }
                    return expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />
                }}
            >
                {columns.map((column, index) => (
                    <Column
                        minWidth={column.minWidth}
                        flexGrow={column.flexGrow}
                        key={`workplan-shiftline-table-${column.field}-${index}`}
                    >
                        <HeaderCell>{column.title}</HeaderCell>
                        {
                            exists(column.field) && column.field.includes("day") 
                                ? <ShiftTemplateCell
                                    key={`workplan-shiftline-table-cell-${column.field}-${index}`}
                                    column={column} 
                                /> 
                                : <Cell 
                                    key={`workplan-shiftline-table-cell-${column.field}-${index}`}
                                    className={`${column.className || ''} table-cell`} 
                                    dataKey={column.field}>
                                        {column.render}
                                </Cell>
                        }
                    </Column>
                ))}
            </Table>
            <div style={{ padding: 20 }}>
                <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                    total={defaultShiftlineData.length}
                    limitOptions={[10, 30, 50]}
                    limit={limit}
                    activePage={page}
                    onChangePage={handleChangePage}
                    onChangeLimit={handleChangeLimit}
                    locale={{
                        total: t('workPlanView.pagination.total'),
                        skip: t('workPlanView.pagination.goTo')
                    }}
                />
            </div>
        </div>

    )
};
export default translate('workplanManager')(WorkplanShiftlineTable);